import React from 'react';
import { useLanguage } from '../../contexts/LanguageContext';
import s from './FullPageLoading.module.css';

/**
 * AB#2201 — the full-page wait shown while the portal resolves the owner's session /
 * onboarding status. It used to be a bare `.spinner` that rendered as a blank dark
 * page; it now says what is happening (announced to screen readers).
 */
const FullPageLoading: React.FC = () => {
    const { t } = useLanguage();
    return (
        <div className={s.wrap} role="status" aria-live="polite" data-testid="full-page-loading">
            <div className="spinner" aria-hidden="true" />
            <span className={s.label}>{t('app.loading')}</span>
        </div>
    );
};

export default FullPageLoading;
